(function () {
  function initSoneaMeditations() {
    var gateRoot = document.querySelector('[data-sml-gate]');
    var legacyRoot = document.querySelector('[data-sml-library]');
    var protectedSections = document.querySelectorAll('[data-sml-protected]');
    var audios = gateRoot
      ? document.querySelectorAll('[data-sml-protected] audio')
      : (legacyRoot ? legacyRoot.querySelectorAll('audio') : []);

    audios.forEach(function (audio) {
      if (audio.dataset.smlBound === '1') return;
      audio.dataset.smlBound = '1';
      audio.addEventListener('play', function () {
        audios.forEach(function (other) {
          if (other !== audio) other.pause();
        });
      });
    });

    if (!gateRoot && legacyRoot) {
      var legacyGate = document.getElementById('SoneaGate');
      var legacyContent = document.getElementById('SoneaContent');
      var legacyBtn = document.getElementById('SoneaGateSubmit');
      var legacyInput = document.getElementById('SoneaGateCode');
      var legacyErr = document.getElementById('SoneaGateError');

      function legacyUnlock() {
        if (legacyGate) {
          legacyGate.setAttribute('hidden', '');
          legacyGate.style.display = 'none';
        }
        if (legacyContent) {
          legacyContent.removeAttribute('hidden');
          legacyContent.style.display = '';
        }
      }

      if (legacyGate && legacyContent && localStorage.getItem('sonea_meditation_access') === '1') {
        legacyUnlock();
      }

      function legacyTryUnlock() {
        if (!legacyInput) return;
        var value = legacyInput.value.trim();
        if (value.length >= 4) {
          localStorage.setItem('sonea_meditation_access', '1');
          if (legacyErr) legacyErr.setAttribute('hidden', '');
          legacyUnlock();
        } else if (legacyErr) {
          legacyErr.removeAttribute('hidden');
        }
      }

      if (legacyBtn && legacyBtn.dataset.smlBound !== '1') {
        legacyBtn.dataset.smlBound = '1';
        legacyBtn.addEventListener('click', legacyTryUnlock);
      }
      if (legacyInput && legacyInput.dataset.smlBound !== '1') {
        legacyInput.dataset.smlBound = '1';
        legacyInput.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            legacyTryUnlock();
          }
        });
      }
      return;
    }

    if (!gateRoot) {
      document.documentElement.classList.remove('sml-gate-locked');
      return;
    }

    var enabled = gateRoot.dataset.enabled === 'true';
    var designMode = gateRoot.dataset.designMode === 'true';
    document.documentElement.classList.toggle('sml-gate-enabled', enabled && !designMode);
    var requiredCode = (gateRoot.dataset.code || '').trim();
    var gate = gateRoot.querySelector('#SoneaGate');
    var btn = gateRoot.querySelector('#SoneaGateSubmit');
    var input = gateRoot.querySelector('#SoneaGateCode');
    var err = gateRoot.querySelector('#SoneaGateError');

    function unlock() {
      document.documentElement.classList.remove('sml-gate-locked');
      protectedSections.forEach(function (section) {
        section.removeAttribute('hidden');
      });
      if (gate) {
        gate.setAttribute('hidden', '');
        gate.style.display = 'none';
      }
    }

    if (!enabled || designMode) {
      unlock();
      return;
    }

    if (localStorage.getItem('sonea_meditation_access') === '1') {
      unlock();
      return;
    }

    function tryUnlock() {
      if (!input) return;
      var value = input.value.trim();
      var valid = requiredCode
        ? value.toLowerCase() === requiredCode.toLowerCase()
        : value.length >= 4;

      if (valid) {
        localStorage.setItem('sonea_meditation_access', '1');
        if (err) err.setAttribute('hidden', '');
        unlock();
      } else if (err) {
        err.removeAttribute('hidden');
      }
    }

    if (btn && btn.dataset.smlBound !== '1') {
      btn.dataset.smlBound = '1';
      btn.addEventListener('click', tryUnlock);
    }
    if (input && input.dataset.smlBound !== '1') {
      input.dataset.smlBound = '1';
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          tryUnlock();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSoneaMeditations);
  } else {
    initSoneaMeditations();
  }

  document.addEventListener('shopify:section:load', initSoneaMeditations);
})();
